var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import * as classNames from 'classnames';
import { Dialog, Icon } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import store from 'src/store';
import { mainApi } from 'src/config';
import styles from './UserProfileDialog.style';
import { getInitials } from 'src/utils/common';
import { countries } from 'src/constants/countries';
import Spinner from 'src/components/reusable/Spinner';
import { addNotification } from 'src/NotificationWrapper';
import { checkIfDevelopmentStage } from 'src/utils/common';
import { setUserProfile } from 'src/auth/store/actions/user.actions';
import { getUserPermissions } from 'src/auth/cognito/organizationApi';
export var reactSelectStyles = {
    control: function (provided, state) { return (__assign(__assign({}, provided), { minHeight: '16px', height: '16px', border: 0, boxShadow: 'none', marginTop: 2 })); },
    valueContainer: function (provided, state) { return (__assign(__assign({}, provided), { height: '20px', padding: '0 6px' })); },
    indicatorSeparator: function (state) { return ({
        display: 'none',
    }); },
    indicatorsContainer: function (provided, state) { return (__assign(__assign({}, provided), { height: '16px', marginTop: 2 })); },
    menu: function (provided) { return (__assign(__assign({}, provided), { zIndex: 9999 })); },
    menuPortal: function (base) { return (__assign(__assign({}, base), { zIndex: 9999 })); },
};
// @ts-ignore
var UserProfileDialog = /** @class */ (function (_super) {
    __extends(UserProfileDialog, _super);
    function UserProfileDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (selectedCountry) {
            _this.setState({ country: selectedCountry.value });
        };
        _this.handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, firstName, lastName, jobTitle, phoneNumber, country, selectedCountryValue, isDevStage, mainApiUrl, pathUrl, apiRes, data, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state, firstName = _a.firstName, lastName = _a.lastName, jobTitle = _a.jobTitle, phoneNumber = _a.phoneNumber, country = _a.country;
                        selectedCountryValue = country;
                        this.setState({ isSaving: true });
                        isDevStage = checkIfDevelopmentStage();
                        mainApiUrl = mainApi(isDevStage);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        pathUrl = void 0;
                        if (!this.state.selectedFile) return [3 /*break*/, 4];
                        return [4 /*yield*/, axios({
                                method: 'post',
                                url: mainApiUrl.command + "/getGenericS3UploadSignedUrl",
                                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
                                data: {
                                    fileExt: this.state.selectedFile.name.split('.').pop(),
                                },
                            })];
                    case 2:
                        apiRes = _b.sent();
                        pathUrl = apiRes.data;
                        // Upload to s3
                        return [4 /*yield*/, axios({
                                method: 'put',
                                url: pathUrl.signedUrl,
                                headers: {
                                    'content-type': this.state.selectedFile.type,
                                },
                                data: this.state.selectedFile,
                            })];
                    case 3:
                        // Upload to s3
                        _b.sent();
                        _b.label = 4;
                    case 4: 
                    // Save the users data
                    return [4 /*yield*/, this.props.saveUserProfile(__assign(__assign({ firstName: firstName, lastName: lastName, jobTitle: jobTitle, country: selectedCountryValue, phoneNumber: phoneNumber }, (!this.state.profilePic && { profilePic: '' })), (pathUrl && { profilePic: pathUrl.s3Path })))
                        // Refetch users data
                    ];
                    case 5:
                        // Save the users data
                        _b.sent();
                        return [4 /*yield*/, getUserPermissions()
                            // save to redux
                        ];
                    case 6:
                        data = _b.sent();
                        // save to redux
                        setUserProfile(data.userData)(store.dispatch);
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _b.sent();
                        // Error toast
                        addNotification({
                            children: (React.createElement("div", { className: "custom-notification" },
                                React.createElement("div", { className: classNames(this.props.classes.error, 'custom-notification__icon') },
                                    React.createElement(Icon, null, "warning")),
                                React.createElement("div", { className: "custom-notification__text" },
                                    React.createElement("p", { className: "word-break" }, this.props.translate('error-saving'))))),
                            position: 'tr',
                            autoDismiss: 15,
                            level: 'error',
                        });
                        this.setState({ isSaving: false });
                        return [2 /*return*/];
                    case 8:
                        this.setState({ isSaving: false });
                        this.props.onClose();
                        return [2 /*return*/];
                }
            });
        }); };
        var _a = _this.props.profile, lastName = _a.lastName, firstName = _a.firstName, jobTitle = _a.jobTitle, profilePic = _a.profilePic, phoneNumber = _a.phoneNumber, country = _a.country;
        _this.state = {
            firstName: firstName,
            lastName: lastName,
            jobTitle: jobTitle,
            profilePic: profilePic,
            phoneNumber: phoneNumber,
            selectedFile: null,
            isSaving: false,
            country: country,
        };
        return _this;
    }
    UserProfileDialog.prototype.render = function () {
        var _this = this;
        var _a = this.props, open = _a.open, tubeColor = _a.tubeColor, onClose = _a.onClose, classes = _a.classes, profile = _a.profile, translate = _a.translate;
        var _b = this.state, firstName = _b.firstName, lastName = _b.lastName, jobTitle = _b.jobTitle, phoneNumber = _b.phoneNumber, country = _b.country;
        var userName = (profile.firstName || '') + " " + (profile.lastName || '');
        return (React.createElement(Dialog, { open: open, onClose: onClose, fullWidth: false, PaperProps: {
                style: {
                    borderRadius: 15,
                },
            } },
            React.createElement("div", { className: classes.wrapper },
                React.createElement("div", { className: classes.innerWrapper },
                    React.createElement("div", { className: classes.crossButton, onClick: function () { return onClose(); } },
                        React.createElement(Icon, null, "close")),
                    React.createElement("div", { className: classes.welcomeMessageTitle }, translate('welcome-msg')),
                    React.createElement("div", { className: classes.userName }, profile.firstName || profile.lastName ? userName : profile.email)),
                React.createElement("div", { className: classes.userDetailsWrapper },
                    React.createElement("div", { className: classes.userDetailTitle }, translate('profile-picture')),
                    this.state.profilePic ? (React.createElement("div", { className: classes.profilePictureDefault },
                        React.createElement("img", { src: this.state.profilePic }),
                        React.createElement("div", { className: classes.clearImg, onClick: function () {
                                _this.setState({ profilePic: '', selectedFile: null });
                            } },
                            React.createElement(Icon, { style: { color: tubeColor } }, "close"),
                            React.createElement("span", null, translate('remove'))))) : (React.createElement("div", { className: classes.profilePictureDefault },
                        React.createElement("span", { className: classes.profilePicText }, profile.firstName || profile.lastName
                            ? getInitials(userName)
                            : (profile.email || '').slice(0, 2).toUpperCase()))),
                    React.createElement("div", { className: classes.uploadPictureButton },
                        React.createElement("input", { accept: "image/*", id: "icon-button-file", onChange: function (e) {
                                if (!e.target && !e.target.files) {
                                    return;
                                }
                                var url = URL.createObjectURL(e.target.files[0]);
                                _this.setState({ profilePic: url, selectedFile: e.target.files[0] });
                            }, type: "file", style: { display: 'none' } }),
                        React.createElement("label", { htmlFor: "icon-button-file" },
                            React.createElement("div", { color: "primary", className: "cursor-pointer" }, translate('upload-picture')))),
                    React.createElement("div", { className: classes.userDetailTitle, style: { textAlign: 'center' } }, translate('your-email')),
                    React.createElement("div", { className: classes.nonEditableText }, profile.email),
                    React.createElement("div", { className: classes.inputRow },
                        React.createElement("div", null,
                            React.createElement("div", { className: classes.userDetailTitle }, translate('first-name')),
                            React.createElement("input", { className: classes.inputField, value: firstName, onChange: function (e) { return _this.setState({ firstName: e.target.value }); }, placeholder: String(translate('first-name-placeholder')) })),
                        React.createElement("div", null,
                            React.createElement("div", { className: classes.userDetailTitle }, translate('last-name')),
                            React.createElement("input", { className: classes.inputField, value: lastName, onChange: function (e) { return _this.setState({ lastName: e.target.value }); }, placeholder: String(translate('last-name-placeholder')) }))),
                    React.createElement("div", { className: classes.inputRow },
                        React.createElement("div", null,
                            React.createElement("div", { className: classes.userDetailTitle }, translate('job-title')),
                            React.createElement("input", { className: classes.inputField, value: jobTitle, onChange: function (e) { return _this.setState({ jobTitle: e.target.value }); }, placeholder: String(translate('job-title-placeholder')) })),
                        React.createElement("div", null,
                            React.createElement("div", { className: classes.userDetailTitle }, translate('company-phone')),
                            React.createElement("input", { type: "number", className: classes.inputField, value: phoneNumber, onChange: function (e) { return _this.setState({ phoneNumber: e.target.value }); }, placeholder: String(translate('company-phone-placeholder')) }))),
                    React.createElement("div", { className: classes.inputRow },
                        React.createElement("div", null,
                            React.createElement("div", { className: classes.userDetailTitle }, translate('country')),
                            React.createElement(Select, { value: country
                                    ? { label: country, value: country }
                                        ? { label: country, value: country }
                                        : { label: 'None', value: 'None' }
                                    : 'Select Your Country', onChange: this.handleChange, placeholder: String(translate('country-placeholder')), className: classes.inputField, styles: reactSelectStyles, menuPortalTarget: document.body, menuPosition: "fixed", options: countries.map(function (country) {
                                    return { label: country, value: country };
                                }) }))),
                    React.createElement("button", { className: classes.saveBtn, onClick: function () { return _this.handleSave(); } }, this.state.isSaving ? (React.createElement("span", null,
                        React.createElement(Spinner, null))) : (translate('save')))))));
    };
    UserProfileDialog = __decorate([
        withStyles(styles, { withTheme: true })
    ], UserProfileDialog);
    return UserProfileDialog;
}(React.Component));
function mapStateToProps(state) {
    return {
        profile: state.auth.user.profile,
    };
}
export default connect(mapStateToProps)(UserProfileDialog);



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/UserProfileDialog.tsx
// module id = 2041
// module chunks = 81